var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "../../interface/IVueDialog";
import LoginService from "../../api/LoginService";
import CommonService from "../../api/CommonService";
var NoticeAfterLogin = (function (_super) {
    __extends(NoticeAfterLogin, _super);
    function NoticeAfterLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tips = [];
        _this.payNotice = {};
        _this.isPayNoticeShow = null;
        _this.hasPayNotice = null;
        _this.payment_modes = [];
        _this.goodsAuth = false;
        _this.checked = false;
        _this.tipIndex = 0;
        _this.notice_content_list = [];
        _this.notRemindFlag = false;
        return _this;
    }
    Object.defineProperty(NoticeAfterLogin.prototype, "notice_sub_type", {
        get: function () {
            return this.tips[this.tipIndex] && this.tips[this.tipIndex].notice_sub_type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isLogoutBtnShow", {
        get: function () {
            return this.notice_sub_type == 6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isOpenBtnShow", {
        get: function () {
            return this.notice_sub_type == 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isPayBtnShow", {
        get: function () {
            return this.notice_sub_type == 4 || this.notice_sub_type == 5 || this.notice_sub_type == 6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isUploadBtnShow", {
        get: function () {
            return (this.notice_sub_type == 1 && this.tips[this.tipIndex].notice_params.type == 2) || this.notice_sub_type == 21;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isDirectBtnShow", {
        get: function () {
            return this.notice_sub_type == 1 && this.tips[this.tipIndex].notice_params.type == 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "notice_button_type", {
        get: function () {
            return this.tips[this.tipIndex] && this.tips[this.tipIndex].button_type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoticeAfterLogin.prototype, "isCustomerBtnShow", {
        get: function () {
            return this.notice_sub_type == 8;
        },
        enumerable: true,
        configurable: true
    });
    NoticeAfterLogin.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.service = LoginService.getInstance();
        this.getMenu();
    };
    NoticeAfterLogin.prototype.mounted = function () {
        if (this.tips) {
            this.tips = this.tips;
            this.notice_content_list = this.tips[0].notice_content.split('\n');
        }
    };
    NoticeAfterLogin.prototype.getMenu = function () {
        var _this = this;
        this.commonService.getMenu().then(function (res) {
            if (res.data.success) {
                var goods = res.data.data.filter(function (item) { return item.power_id == 18; });
                var goodsManage = [];
                if (goods.length) {
                    goodsManage = (goods[0].children || []).filter(function (item) { return item.power_id == 17; });
                }
                _this.goodsAuth = goodsManage.length ? true : false;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    NoticeAfterLogin.prototype.checkboxChange = function (val, notice_id) {
        this.notRemindFlag = val;
        if (val) {
            this.dontRemind(notice_id);
        }
    };
    NoticeAfterLogin.prototype.viewPreNotice = function () {
        this.tipIndex--;
        this.notice_content_list = this.tips[this.tipIndex].notice_content.split('\n');
    };
    NoticeAfterLogin.prototype.close = function () {
        this.$closeDialog();
    };
    NoticeAfterLogin.prototype.toAddGoods = function () {
        this.close();
        if (!this.goodsAuth) {
            this.$message.error('当前账号暂无相关权限，如须使用，请联系您的企业管理员开通。');
            return;
        }
        this.$emit('openAddGood');
    };
    NoticeAfterLogin.prototype.toDirectSeeding = function () {
        window.open("https://mp.weixin.qq.com/s?__biz=Mzg5NTIyMzc1MQ==&mid=2247483654&idx=1&sn=274a11893920c5029b0d60af33d6a072&chksm=c012d3aef7655ab84bd3130f0b06c4c52538c3b4f6f2d0d67f2bbec68c94e9380523d16cd710&token=1031581773&lang=zh_CN#rd");
    };
    NoticeAfterLogin.prototype.hasRead = function () {
        if (this.tipIndex == this.tips.length - 1) {
            this.close();
        }
        else {
            this.tipIndex++;
            this.notice_content_list = this.tips[this.tipIndex].notice_content.split('\n');
            var notice = this.tips[this.tipIndex];
            if (this.notRemindFlag) {
                this.dontRemind(notice.notice_id);
            }
        }
    };
    NoticeAfterLogin.prototype.dontRemind = function (notice_id) {
        var _this = this;
        this.service.noticeRemindUpdate({ notice_id: notice_id }).then(function (res) {
            console.log('不再提醒');
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    NoticeAfterLogin.prototype.toOpenService = function (notice) {
        this.close();
        this.$emit('openMyService', notice);
    };
    NoticeAfterLogin.prototype.toPayService = function (notice) {
        this.close();
        this.$emit('payMyService', notice);
    };
    NoticeAfterLogin.prototype.toMessage = function (notice) {
        this.close();
        this.$emit('supplierMessage', notice);
        if (this.notice_button_type === 2) {
            this.dontRemind(notice.notice_id);
        }
    };
    NoticeAfterLogin.prototype.logout = function () {
        this.close();
        this.$emit('logout');
    };
    NoticeAfterLogin = __decorate([
        Component
    ], NoticeAfterLogin);
    return NoticeAfterLogin;
}(IVueDialog));
export default NoticeAfterLogin;
